import {useState} from "react";

import {DataLoadingStatus} from "shared/types/common";
import {LogType, logTypes} from "../types";
import {logsService} from "../services/logsService";

export const useLogs = () => {
    const [lines, setLines] = useState(100);
    const [includeOld, setIncludeOld] = useState(false);
    const [selectedLogTypeIdx, setSelectedLogTypeIdx] = useState(1);
    const [dataLoadingStatus, setDataLoadingStatus] = useState<DataLoadingStatus>(DataLoadingStatus.NotLoaded);
    const [logs, setLogs] = useState<{level: LogType, log: string[]}|undefined>(undefined);

    if (dataLoadingStatus === DataLoadingStatus.NotLoaded){
        setDataLoadingStatus(DataLoadingStatus.Loading);
        logsService.getLog(logTypes[selectedLogTypeIdx], lines, includeOld).then(resp => {
            if (resp.errorCode === undefined) {
                setLogs({level: resp.level, log: resp.log});
                setDataLoadingStatus(DataLoadingStatus.Loaded);
            } else {
                setDataLoadingStatus(DataLoadingStatus.Error);
            }
        })
    }

    if (dataLoadingStatus === DataLoadingStatus.Loaded && logs?.level !== logTypes[selectedLogTypeIdx]) {
        setDataLoadingStatus(DataLoadingStatus.NotLoaded);
        setLogs(undefined);
    }

    return {
        lines, setLines,
        includeOld, setIncludeOld,
        selectedLogTypeIdx, setSelectedLogTypeIdx,
        dataLoadingStatus, setDataLoadingStatus,
        logs, setLogs,
    };
};
